import React from "react";
import PropTypes from "prop-types";
import { styled } from "@mui/material";

const LayoutWrapperDiv = styled("div")({
	alignItems: "start",
	borderRadius: "16px",
	flexDirection: "row",
	height: "100%",
	justifyContent: "space-between",
	padding: "12px 24px 24px",
	width: "100%",
});

function LayoutWrapper({ children }) {
	return <LayoutWrapperDiv>{children}</LayoutWrapperDiv>;
}

LayoutWrapper.defaultProps = {
	children: null,
};

LayoutWrapper.propTypes = {
	children: PropTypes.object,
};

export default LayoutWrapper;
